import React from "react";
import socketIO from "socket.io-client";

import { NEW_HOST_URL } from "../config/envConfig";

// export const socket = socketIO.connect(SOCKET_URL, { withCredentials: true, transports: ["websocket"] });
export const webhookSocket = socketIO.connect(NEW_HOST_URL, {
  withCredentials: true,
  transports: ["websocket"],
});

export const SocketContext = React.createContext();
